import { BuildType } from '@/services/ApiService';
import { SkillSearchRequest, SkillSearchResponse } from '@/apiTypes/SkillSearchTypes';

export const skillSearchApiEndpoints = (build: BuildType) => ({
    searchSkills: build.query<SkillSearchResponse, SkillSearchRequest>({
        query: body => ({
            url: 'skills/search',
            method: 'POST',
            body,
        }),
    }),
});
